import { Component, OnInit } from '@angular/core';
import { ErrorTracking } from './error-tracking.service';

@Component({
  selector: 'fl-error-tracking',
  template: ` <ng-container></ng-container> `,
})
export class ErrorTrackingComponent implements OnInit {
  constructor(private errorTracking: ErrorTracking) {}

  ngOnInit() {
    this.errorTracking.setupSentrySDK();
  }
}
